import React, { FC, HTMLAttributes } from 'react'
import { ReturnSailSepIcon } from '@/root/ui/shared'
import cn from 'classnames'

interface DividerProps extends HTMLAttributes<HTMLDivElement> {
  variant: 'default' | 'cancelled' | 'light'
}

const colorMap: Record<DividerProps['variant'], string> = {
  default: 'black',
  light: 'base-very-light',
  cancelled: 'alert-base',
}

const borderColor: Record<DividerProps['variant'], string> = {
  default: 'border-black',
  light: 'border-base-very-light',
  cancelled: 'border-t-4 border-alert-base',
}

export const Divider: FC<DividerProps> = ({ variant }) => {
  const hrClassName = cn('flex-1', borderColor[variant])

  return (
    <div className="absolute top-0 left-0 z-10 flex w-full -translate-y-1/2 items-center">
      <hr className={hrClassName} />
      <div className="px-2.5">
        <ReturnSailSepIcon width={48} color={colorMap[variant]} />
      </div>
      <hr className={hrClassName} />
    </div>
  )
}
